const collator = new Intl.Collator(['en', 'th'], { numeric: true, sensitivity: 'base' });

export default collator;